import React, { useState } from 'react';
import { useUser } from 'src/auth/UserContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { handleLogout } from 'src/auth/AuthService';
import logo from 'src/assets/topmaterial-logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import NavButton from 'src/components/common/NavButton';

const Header: React.FC = () => {
  const { setFirebaseUser, setPlatformUser } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const navigateTo = (path: string, event?: React.MouseEvent<HTMLButtonElement>) => {
    if (event?.metaKey || event?.ctrlKey) {
      window.open(path, '_blank');
    } else {
      navigate(path);
    }
  };

  const isActive = (path: string): boolean => location.pathname.startsWith(path);

  const toggleUserMenu = () => {
    setIsUserMenuOpen(prev => !prev);
  };

  return (
    <header className="header">
      {/* Logo Section */}
      <div className="header-logo-section">
        <h1 className="header-logo">
          <NavButton path="/main" className="header-logo-button">
            <img src={logo} alt="Logo" className="logo-image" />
          </NavButton>
        </h1>
      </div>

      {/* Navigation Section */}
      <nav className="header-nav">
        <ul className="header-nav-list">
          <li className="header-nav-item">
            <NavButton
              path="/materials"
              className={`header-nav-button ${isActive('/materials') ? 'active' : ''}`}
            >
              물질
            </NavButton>
          </li>
          <li className="header-nav-item">
            <NavButton
              path="/formulations"
              className={`header-nav-button ${isActive('/formulations') ? 'active' : ''}`}
            >
              전극 조성
            </NavButton>
          </li>
          <li className="header-nav-item">
            <NavButton
              path="/work-orders"
              className={`header-nav-button ${isActive('/work-orders') ? 'active' : ''}`}
            >
              작업지시서
            </NavButton>
          </li>
          <li className="header-nav-item user-menu">
            <button className="user-icon-button" onClick={toggleUserMenu}>
              <FontAwesomeIcon icon={faUserCircle} />
            </button>
            {isUserMenuOpen && (
              <ul className="user-menu-dropdown">
                <li onClick={() => navigateTo('/user-profile')}>My Profile</li>
                <li onClick={() => handleLogout(setFirebaseUser, setPlatformUser, navigate)}>
                  Logout
                </li>
              </ul>
            )}
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
